export default "/images/thermometer.svg?3f4fcca9a253990f6a685179eb50bec4";